import React from "react";
import Dashboard from "../../MasterDashboard/Dashboard";

const AdminDashboard = () => {
  const uid = sessionStorage.getItem("userUid");
  return (
    <div>
      <Dashboard uid={uid} />
    </div>
  );
};

export default AdminDashboard;
